module.exports = __webpack_public_path__ + "product.variant-gallery-a504d574.html";